import { audioID, videoID, volume } from "@/state/config";
import { audioDevices, videoDevices } from "@/state/devices";
import clsx from "clsx";
import type { FunctionalComponent } from "preact";
import Device from "./Device";
import FPS from "./Fps";
import Resolution from "./Resolution";
import Volume from "./Volume";

export interface Props {
    class?: string;
}

const Selection: FunctionalComponent<Props> = (props) => {
    const onAudioSelected = (id: string) => {
        audioID.value = id;
    };

    const onVideoSelected = (id: string) => {
        videoID.value = id;
    };

    const volumeIcon = () => {
        if (volume.value > 0.75) {
            return "🔊";
        }
        if (volume.value > 0.5) {
            return "🔉";
        }
        if (volume.value > 0) {
            return "🔈";
        }
        return "🔇";
    };

    return (
        <div class={clsx("text-white", props.class)}>
            <Device
                class="mt-4"
                onSelected={onAudioSelected}
                current={audioID.value}
                devices={audioDevices.value}
                headline="🎙️ Audio"
            />
            {audioDevices.value.length > 0 && (
                <Volume
                    class="mt-4"
                    headline={`${volumeIcon()} Volu(<span class="font-extrabold text-sm">M</span>)e`}
                />
            )}

            <Device
                onSelected={onVideoSelected}
                class="mt-4"
                current={videoID.value}
                devices={videoDevices.value}
                headline="🎥 Video"
            />

            {videoDevices.value.length > 0 && (
                <>
                    <Resolution class="mt-4" headline="📺 Resolution" />
                    <FPS class="mt-4" headline="🎞️ FPS" />
                </>
            )}
        </div>
    );
};

export default Selection;
